function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, useSlots, computed, provide, getCurrentInstance, openBlock, createElementBlock, normalizeClass, unref, createBlock, withCtx, normalizeStyle, createElementVNode, toDisplayString } from 'vue';
import '../../../hooks/index.mjs';
import '../../form/index.mjs';
import '../../virtual-list/index.mjs';
import { useTree } from './composables/useTree.mjs';
import ElTreeNode from './tree-node.mjs';
import { treeProps, treeEmits, ROOT_TREE_INJECTION_KEY } from './virtual-tree.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { formItemContextKey } from '../../form/src/constants.mjs';
import { useLocale } from '../../../hooks/use-locale/index.mjs';
import { useNamespace } from '../../../hooks/use-namespace/index.mjs';
import FixedSizeList from '../../virtual-list/src/components/fixed-size-list.mjs';
const __default__ = defineComponent({
  name: "ElTreeV2"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: treeProps,
  emits: treeEmits,
  setup(__props, _ref) {
    let expose = _ref.expose,
      emit = _ref.emit;
    const props = __props;
    const slots = useSlots();
    const treeNodeSize = computed(() => props.itemSize);
    provide(ROOT_TREE_INJECTION_KEY, {
      ctx: {
        emit,
        slots
      },
      props,
      instance: getCurrentInstance()
    });
    provide(formItemContextKey, void 0);
    const _useLocale = useLocale(),
      t = _useLocale.t;
    const ns = useNamespace("tree");
    const _useTree = useTree(props, emit),
      flattenTree = _useTree.flattenTree,
      isNotEmpty = _useTree.isNotEmpty,
      toggleExpand = _useTree.toggleExpand,
      isExpanded = _useTree.isExpanded,
      isIndeterminate = _useTree.isIndeterminate,
      isChecked = _useTree.isChecked,
      isDisabled = _useTree.isDisabled,
      isCurrent = _useTree.isCurrent,
      isForceHiddenExpandIcon = _useTree.isForceHiddenExpandIcon,
      handleNodeClick = _useTree.handleNodeClick,
      handleNodeCheck = _useTree.handleNodeCheck,
      toggleCheckbox = _useTree.toggleCheckbox,
      getCurrentNode = _useTree.getCurrentNode,
      getCurrentKey = _useTree.getCurrentKey,
      setCurrentKey = _useTree.setCurrentKey,
      getCheckedKeys = _useTree.getCheckedKeys,
      getCheckedNodes = _useTree.getCheckedNodes,
      getHalfCheckedKeys = _useTree.getHalfCheckedKeys,
      getHalfCheckedNodes = _useTree.getHalfCheckedNodes,
      setChecked = _useTree.setChecked,
      setCheckedKeys = _useTree.setCheckedKeys,
      filter = _useTree.filter,
      setData = _useTree.setData,
      getNode = _useTree.getNode,
      expandNode = _useTree.expandNode,
      collapseNode = _useTree.collapseNode,
      setExpandedKeys = _useTree.setExpandedKeys;
    expose({
      toggleCheckbox,
      getCurrentNode,
      getCurrentKey,
      setCurrentKey,
      getCheckedKeys,
      getCheckedNodes,
      getHalfCheckedKeys,
      getHalfCheckedNodes,
      setChecked,
      setCheckedKeys,
      filter,
      setData,
      getNode,
      expandNode,
      collapseNode,
      setExpandedKeys
    });
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([unref(ns).b(), {
          [unref(ns).m("highlight-current")]: _ctx.highlightCurrent
        }]),
        role: "tree"
      }, [unref(isNotEmpty) ? (openBlock(), createBlock(unref(FixedSizeList), {
        key: 0,
        "class-name": unref(ns).b("virtual-list"),
        data: unref(flattenTree),
        total: unref(flattenTree).length,
        height: _ctx.height,
        "item-size": unref(treeNodeSize),
        "perf-mode": _ctx.perfMode
      }, {
        default: withCtx(_ref2 => {
          let data = _ref2.data,
            index = _ref2.index,
            style = _ref2.style;
          return [(openBlock(), createBlock(ElTreeNode, {
            key: data[index].key,
            style: normalizeStyle(style),
            node: data[index],
            expanded: unref(isExpanded)(data[index]),
            "show-checkbox": _ctx.showCheckbox,
            checked: unref(isChecked)(data[index]),
            indeterminate: unref(isIndeterminate)(data[index]),
            "item-size": unref(treeNodeSize),
            disabled: unref(isDisabled)(data[index]),
            current: unref(isCurrent)(data[index]),
            "hidden-expand-icon": unref(isForceHiddenExpandIcon)(data[index]),
            onClick: unref(handleNodeClick),
            onToggle: unref(toggleExpand),
            onCheck: unref(handleNodeCheck)
          }, null, 8, ["style", "node", "expanded", "show-checkbox", "checked", "indeterminate", "item-size", "disabled", "current", "hidden-expand-icon", "onClick", "onToggle", "onCheck"]))];
        }),
        _: 1
      }, 8, ["class-name", "data", "total", "height", "item-size", "perf-mode"])) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(unref(ns).e("empty-block"))
      }, [createElementVNode("span", {
        class: normalizeClass(unref(ns).e("empty-text"))
      }, toDisplayString((_a = _ctx.emptyText) != null ? _a : unref(t)("el.tree.emptyText")), 3)], 2))], 2);
    };
  }
}));
var TreeV2 = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "tree.vue"]]);
export { TreeV2 as default };